import { Component, OnInit, OnChanges } from '@angular/core';
import { OrganizationService } from '../../shared/services/organization.service';
import { Configuration } from '../../app.constants';

declare var $: any;

@Component({
  selector: 'app-company-hierarchy',
  templateUrl: './company-hierarchy.component.html',
  styleUrls: ['./company-hierarchy.component.css']
})
export class CompanyHierarchyComponent implements OnInit, OnChanges {
  oc = '';

  options = { };
  public serverApiUrl;
  constructor(public organizationService: OrganizationService,
              public config: Configuration) { }
  ngOnChanges () {
  }
  ngOnInit() {
    this.serverApiUrl = this.config.StaticImageUrl;
    this.organizationService.getCompanyHeirarchy().subscribe(data => {
      this.options = data['Opcos'];
      $('#orga_chart_main').on('mouseenter mouseleave',function() {
        $('.popover').removeClass('show');
      });
      $('#chartContainerId2').on('mouseleave', '.isNode', function(event) {
        var node= $(this);
        $('.popover').removeClass('show');
      });
      $('#chartContainerId2').on('mouseenter', '.isNode', function(event)  {
        event.stopPropagation();
        var node= $(this);
        let companyName= node.attr('company-name'),
        companyId = node.attr('company-id'),
        companyType = node.attr('company-type'),
        companyCountry = node.attr('company-country'),
        companyAvatar = node.attr('company-avatar');
        node.popover({
          trigger: 'manual',
          container: 'body',
          template: `<div class="popover" role="tooltip">
              <div class="arrow"></div>
              <div class="org-popover xs-pl-15 xs-pr-15 xs-pt-10 xs-pb-10">
                <div class="row ">
                  <div class="col-xs-12 xs-pb-5" style="text-align:left">
                    <img src='https://s3-ap-southeast-1.amazonaws.com/epeoples3-production/`+companyAvatar+`' height="50"/>
                  </div>
                </div>
                <div class="row" style="font-size:16px;color: #1592E6;font-weight: 400;">
                  <div class="col-xs-12 xs-pb-5 xs-pt-5">
                    <p class="xs-mb-0">`+companyName+`</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <p>`+companyId+`</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-6">
                    <p><b>Company Type</b></p>
                  </div>
                  <div class="col-xs-6">
                    <p>`+companyType+`</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-6">
                    <p><b>Country</b></p>
                  </div>
                  <div class="col-xs-6">
                    <p>`+companyCountry+`</p>
                  </div>
                </div>


              </div>
            </div>`
        })
        node.popover('show');
      });
      this.oc = $('#chartContainerId2').orgchart({
        data: this.options,
        nodeTitle: 'nodeTitlePro',
        nodeContent: 'nodeContentPro',
        draggable: false,
        pan: false,
        zoom: false,
        visibleLevel: 2,
        exportButton: false,
        nodeTemplate: function(data) {
          return `<div class="borderBox isNode" company-name="`+data.comp.company.companyName+`" company-avatar="`+data.comp.company.avatarUrl+`"
            company-type="`+data.comp.company.companyType+`" company-country="`+data.comp.company.countryOfReference+`"
            company-id="`+data.comp.company.companyId+`"
           data-toggle="popover"  data-content="Org popover" data-animation="false">
                  <div class="col-12">
                    <div class="container-fluid row">
                      <div class="col-12">
                        <img src='https://s3-ap-southeast-1.amazonaws.com/epeoples3-production/`+ data.comp.company.avatarUrl  +` '  height="40px"/>
                      </div>
                    </div>
                    <div class="container-fluid row">
                      <div class="col-12">
                        <p>`+ data.name +`</p>
                      </div>
                    </div>
                    </div>
                  </div>`;
        },
        initCompleted: function() {
        }
      }).on('nodedrop.orgchart', (e) => {
        this.options = e.data;
      })
    },err => {
      console.log(err);
    });
  }

  findCompany(id) {
  }

  showPopup(data) {
  }

}
